module.exports = __webpack_public_path__ + "img/x-circle.b47b092a.svg";